import React from 'react';
import { Outlet } from 'react-router-dom';
import { ContentBreadcrumbs } from '@/features/shell/BreadcrumbBar';
import { ShellSearch } from '@/features/shell/ShellSearch';

/** Full-width browse chrome — sessions live on Ask RCM only. */
export function LibraryLayout() {
  return (
    <div className="app-frame app-frame--shell-layout h-full flex flex-col min-h-0">
      <div className="app-frame-inner flex flex-1 min-h-0">
        <main className="app-content-box flex flex-col min-h-0 min-w-0">
          <ContentBreadcrumbs defaultToolbar={<ShellSearch />} />
          <div className="flex-1 min-h-0 min-w-0 flex flex-col overflow-hidden">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
